import type { ThreadMembershipStatusStatus } from './threadMembershipStatusStatus';

export interface ThreadMembershipStatus {
  /** @nullable */
  acceptedAt?: string | null;
  /** @nullable */
  invitedBy?: string | null;
  /** @nullable */
  requestedAt?: string | null;
  status: ThreadMembershipStatusStatus;
}
